import Layouts from "../../Layouts/Layouts";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import BlogDetailsCode from "../../Blog/BlogDetailsCode";
import Author1 from "../../../assets/img/blogs/authors/1.png";
import Blog8_1 from "../../../assets/img/blogs/details/blog8/1.jpg";
import Blog8_2 from "../../../assets/img/blogs/details/blog8/2.mp3";
import Blog8_3 from "../../../assets/img/blogs/details/blog8/3.jpg";
import Blog8_4 from "../../../assets/img/blogs/details/blog8/4.jpg";
import Blog8_5 from "../../../assets/img/blogs/details/blog8/5.jpg";
import BlogDetailsAudio from "../../Blog/BlogDetailsAudio";
import BlogDetailsVideo from "../../Blog/BlogDetailsVideo";

function Blog8() {

    const code1 = `Login: <https://flaws2-security.signin.aws.amazon.com/console>
Account ID: 322079859186
Username: security
Password: password
Access Key: AKIAIUFNQ2WCOPTEITJQ
Secret Key: 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`;

    const code2 = `test -d ~/.linuxbrew && eval "$(~/.linuxbrew/bin/brew shellenv)"
test -d /home/linuxbrew/.linuxbrew && eval "$(/home/linuxbrew/.linuxbrew/bin/brew shellenv)"
test -r ~/.bash_profile && echo "eval \\"\\$($(brew --prefix)/bin/brew shellenv)\\"" >> ~/.bash_profile
echo "eval \\"\\$($(brew --prefix)/bin/brew shellenv)\\"" >> ~/.profile
`;

    const code3 = `# Store AWS credentials for the "security" profile
└─$  aws-vault add security
Enter Access Key Id: ABDCDEFDASDASF
Enter Secret Key: %%%

# Execute a get-caller-identity command (using temporary credentials)
└─$ aws-vault exec security -- aws sts get-caller-identity  
{
    "UserId": "AIDAJXZBU42TNFRNGBBFI",
    "Account": "322079859186",
    "Arn": "arn:aws:iam::322079859186:user/security"
}                                                                                                                                                                                                  

# open a browser window and log in to the AWS Console
└─$ aws-vault login security

# List credentials
└─$ aws-vault list
Profile                  Credentials              Sessions
=======                  ===========              ========                    
security                 security                 sts.GetSessionToken:54m42s
`;

    const code4 = `┌──(kali㉿kali)-[~]
└─$ mkdir flaws2logs
`;

    const code5 = `┌──(kali㉿kali)-[~/flaws2logs]
└─$ aws-vault exec security -- aws s3 sync s3://flaws2-logs .
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2305Z_83VTWZ8Z0kiEC7Lq.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2305Z_83VTWZ8Z0kiEC7Lq.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_7J9NEIxrjJsrlXSd.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_7J9NEIxrjJsrlXSd.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_A1lhv3sWzzRIBFVk.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_A1lhv3sWzzRIBFVk.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_rp9i9zxR2Vcpqfnz.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_rp9i9zxR2Vcpqfnz.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2235Z_cR9ra7OH1rytWyXY.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2235Z_cR9ra7OH1rytWyXY.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2305Z_zKlMhON7EpHala9u.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2305Z_zKlMhON7EpHala9u.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_jQajCuiobojD8I4y.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_jQajCuiobojD8I4y.json.gz
download: s3://flaws2-logs/AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_jJW5HfNtz7kOnvcP.json.gz to AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/653711331788_CloudTrail_us-east-1_20181128T2310Z_jJW5HfNtz7kOnvcP.json.gz
`;

    const code6 = `┌──(kali㉿kali)-[~/flaws2logs]
└─$ aws-vault exec security -- aws --profile target_security sts get-caller-identity
{
    "UserId": "AROAIKRY5GULQLYOGRMNS:botocore-session-1654835880",
    "Account": "653711331788",
    "Arn": "arn:aws:sts::653711331788:assumed-role/security/botocore-session-1654835880"
}

# OR

┌──(kali㉿kali)-[~/flaws2logs]
└─$ aws-vault exec target_security -- aws sts get-caller-identity 
{
    "UserId": "AROAIKRY5GULQLYOGRMNS:1654836198058317660",
    "Account": "653711331788",
    "Arn": "arn:aws:sts::653711331788:assumed-role/security/1654836198058317660"
}
`;

    const code7 = `┌──(kali㉿kali)-[~/flaws2logs]
└─$ aws-vault exec target_security -- aws s3 ls                  
2018-11-20 14:50:08 flaws2.cloud
2018-11-20 13:45:26 level1.flaws2.cloud
2018-11-20 20:41:16 level2-g9785tw8478k4awxtbox9kk3c5ka8iiz.flaws2.cloud
2018-11-26 14:47:22 level3-oc6ou6dnkw8sszwvdrraxc5t5udrsw3s.flaws2.cloud
2018-11-27 15:37:27 the-end-962b72bjahfm5b4wcktm8t9z4sapemjb.flaws2.cloud
`;

    const code8 = `┌──(kali㉿kali)-[~/flaws2logs]
└─$ cd AWSLogs/653711331788/CloudTrail/us-east-1/2018/11/28/
`;

    const code9 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec gunzip {} \\;                      
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2235Z_cR9ra7OH1rytWyXY.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2310Z_rp9i9zxR2Vcpqfnz.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2310Z_jQajCuiobojD8I4y.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2305Z_83VTWZ8Z0kiEC7Lq.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2310Z_A1lhv3sWzzRIBFVk.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2310Z_7J9NEIxrjJsrlXSd.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2310Z_jJW5HfNtz7kOnvcP.json: unknown suffix -- ignored
gzip: ./653711331788_CloudTrail_us-east-1_20181128T2305Z_zKlMhON7EpHala9u.json: unknown suffix -- ignored
`;

    const code10 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq
`;

    const code11 = `{
  "Records": [
    {
      "eventVersion": "1.05",
      "userIdentity": {
        "type": "AWSService",
        "invokedBy": "ecs-tasks.amazonaws.com"
      },
      "eventTime": "2018-11-28T22:31:59Z",
      "eventSource": "sts.amazonaws.com",
      "eventName": "AssumeRole",
      "awsRegion": "us-east-1",
      "sourceIPAddress": "ecs-tasks.amazonaws.com",
      "userAgent": "ecs-tasks.amazonaws.com",
      "requestParameters": {
        "roleSessionName": "d190d14a-2404-45d6-9113-4eda22d7f2c7",
        "roleArn": "arn:aws:iam::653711331788:role/level3"
      },
      "responseElements": {
        "credentials": {
          "sessionToken": "FQoGZXIvYXdzEFAaDEbnJXLefTT+kjlmKSKSBNgEUj8tJVL+szjaH5q2npYc2FIPgrLmfkRjK9KqtSW7+lo4WxteBTd77aeAcmIip4GceNBbU86zxGgS1IdNBzEOLnDw6biAzijG0Du/Qazx136qjy+kahHxPlR36C4y/0QrCUZpTFmP3uELsRIKkvhGvuBr6S10pTOZ+GjtUXN3iFV8Ea0KOo/fSP0d4LbZGwI957aJxs2I7N8ji/lKTfwPdq+sxXvSWnaOseinUxZUDS0zdI69CKb6C+qwhR5YTifqyuOvC9OoSlfcBN2FyHpRZf5Bd+Z+mPYTldbAvD/HcdbQo7U4jqlR2WGuXoBfwvypt/Kb6HtPp4g9O0HlTCc7Sb4uiJY81WMbaNFmmYXyj62gi+BN5QaA90YhWn9cU1x9gqt0uEgvSk/RdrwtulTtNyJcuuFvhlD1gaJHGc4eCoWApr+J9nrbPTvSo00sc8IYIVvwOi3NRsmP+ZA9aQOV/qg2L1cYxScQrQ/pKVOnYWJ4XuB0WL8gRYdo1bGI6LWGAtOV+fzVoXU0SfWH7UmPcvttqkWsv1Rr50pspmJneXeY6Ge1szNsvyHqmPFJj7GAXnEKl9xthHK3IaDc6HEprFqYw8SyQqYWGdpeism2S+V4XpIMbQJlC06BxyOg94H0Fiffzs8wwnCUpBU0s69X2tN8sxb4U3FqKl28mwCOuuaweZeGWq5MWxU7Fop2dmjaKN+u/N8F",
          "accessKeyId": "ASIAZQNB3KHGNXWXBSJS",
          "expiration": "Nov 29, 2018 4:31:59 AM"
        }
      },
      "requestID": "6b7d6c60-f35d-11e8-becc-39e7d43d4afe",
      "eventID": "6177ca7e-860e-482c-bde9-50c735af58d6",
      "resources": [
        {
          "ARN": "arn:aws:iam::653711331788:role/level3",
          "accountId": "653711331788",
          "type": "AWS::IAM::Role"
        }
      ],
      "eventType": "AwsApiCall",
      "recipientAccountId": "653711331788",
      "sharedEventID": "1d18bf74-8392-4496-9dc4-a45cb799b8b4"
    },
    {
      "eventVersion": "1.05",
      "userIdentity": {
        "type": "AWSService",
        "invokedBy": "ecs-tasks.amazonaws.com"
      },
      "eventTime": "2018-11-28T22:31:59Z",
      "eventSource": "sts.amazonaws.com",
      "eventName": "AssumeRole",
      "awsRegion": "us-east-1",
      "sourceIPAddress": "ecs-tasks.amazonaws.com",
      "userAgent": "ecs-tasks.amazonaws.com",
      "requestParameters": {
        "roleSessionName": "d190d14a-2404-45d6-9113-4eda22d7f2c7",
        "roleArn": "arn:aws:iam::653711331788:role/ecsTaskExecutionRole"
      },
      "responseElements": {
        "credentials": {
          "sessionToken": "FQoGZXIvYXdzEFAaDAhihig4wSQxSSiMjSKSBOW1B0tXzW8SIP7MtRZEikuZamVqb7hEQtmgX5LDeDzpOxpP4G9U8r3cZK74HNErY8W+Scri3Y8NVr/VO7MyzIXnpXiEDo10JfNYnA+urhxB+rYtPF6o8uzm40w/lqdq1/DyOkYYuFRtqWfS4Jy1t83KYAFTuX5IkTGekMidOkIcdnHjsZKQSqKs4U3MQ4doUG4nCyEERDv9yckTPq/R4fKEPTF1BN0jycyiSiR3OTPAWaLGMGxHthAKSA5IXosrPBAq0yD2HhSKZc0kbskCZyGOQCcmVAQK4IdEjyk4Lytc+PEDasvWiGoCQPEqlwwqFJm7EPm838MjCTi4ojN9nVYRP9hFYkXdvnVG6ScwoBfbg135vN1bqYgEKDncW780xUBRYwElM4Q2/6zv7DMj0UegbRJmAwtys4phLrItQqNLWPmBbW/pNgMYoT1IKfzDmuc27AyTHtL8t25hkYOLWZG19EYKm+XeHU9gbs0aDTPssjBFPZp7ssR35IHhgcw5m+etXSoXMxMuHNbVR46ZJ6uieR8roEZ8QfiIijyB8J7i2sH2JOY0HIOonbVYmqdtv++0D+1idTO+6ZbXJIKhEmDmZZDeenF2ZXQGH4PgA4udIdBXnhVLzVFkEKc1MWG3aAhuOhZLvnXkOpkn1XjwfDx3N0UyenOUR4x/gkY9+MEXMZAyO8Va2Y1vNZvnSCvTJtHDKN+u/N8F",
          "accessKeyId": "ASIAZQNB3KHGMG7YRUEW",
          "expiration": "Nov 29, 2018 4:31:59 AM"
        }
      },
      "requestID": "6b80a0b1-f35d-11e8-becc-39e7d43d4afe",
      "eventID": "457af3a9-0b1b-44ca-91e1-8f4a0f873149",
      "resources": [
        {
          "ARN": "arn:aws:iam::653711331788:role/ecsTaskExecutionRole",
          "accountId": "653711331788",
          "type": "AWS::IAM::Role"
        }
      ],
      "eventType": "AwsApiCall",
      "recipientAccountId": "653711331788",
      "sharedEventID": "5397e1a9-82c7-4a00-9b1c-e44cbd688aa1"
    }
  ]
}
{
`;

    const code12 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq '.Records[]|.eventName'
"AssumeRole"
"AssumeRole"
"GetObject"
"GetObject"
"ListBuckets"
"CreateLogStream"
"BatchGetImage"
"GetDownloadUrlForLayer"
"CreateLogStream"
"AssumeRole"
"CreateLogStream"
"CreateLogStream"
"ListImages"
"CreateLogStream"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"Invoke"
"GetObject"
"GetObject"
"GetObject"
"ListObjects"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"GetObject"
"Invoke"
`;

    const code13 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq -cr '.Records[]|[.eventTime, .eventName]|@tsv' | sort                                                                                                                                                                 130 ⨯
2018-11-28T22:31:59Z    AssumeRole
2018-11-28T22:31:59Z    AssumeRole
2018-11-28T23:02:56Z    GetObject
2018-11-28T23:02:56Z    GetObject
2018-11-28T23:02:56Z    GetObject
2018-11-28T23:02:56Z    GetObject
2018-11-28T23:02:57Z    GetObject
2018-11-28T23:03:08Z    GetObject
2018-11-28T23:03:08Z    GetObject
2018-11-28T23:03:08Z    GetObject
2018-11-28T23:03:08Z    GetObject
2018-11-28T23:03:08Z    GetObject
2018-11-28T23:03:11Z    GetObject
2018-11-28T23:03:11Z    GetObject
2018-11-28T23:03:12Z    AssumeRole
2018-11-28T23:03:12Z    CreateLogStream
2018-11-28T23:03:13Z    CreateLogStream
2018-11-28T23:03:13Z    Invoke
2018-11-28T23:03:14Z    GetObject
2018-11-28T23:03:17Z    GetObject
2018-11-28T23:03:18Z    GetObject
2018-11-28T23:03:20Z    CreateLogStream
2018-11-28T23:03:20Z    Invoke
2018-11-28T23:03:35Z    CreateLogStream
2018-11-28T23:03:50Z    CreateLogStream
2018-11-28T23:04:54Z    ListObjects
2018-11-28T23:05:10Z    GetObject
2018-11-28T23:05:12Z    GetObject
2018-11-28T23:05:12Z    GetObject
2018-11-28T23:05:53Z    ListImages
2018-11-28T23:06:17Z    BatchGetImage
2018-11-28T23:06:33Z    GetDownloadUrlForLayer
2018-11-28T23:07:08Z    GetObject
2018-11-28T23:07:08Z    GetObject
2018-11-28T23:09:28Z    ListBuckets
2018-11-28T23:09:36Z    GetObject
2018-11-28T23:09:36Z    GetObject
`;

    const code14 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq -cr '.Records[]|[.eventTime, .sourceIPAddress, .userIdentity.arn, .userIdentity.accountId, .userIdentity.type, .eventName]|@tsv' | sort
2018-11-28T22:31:59Z    ecs-tasks.amazonaws.com                 AWSService      AssumeRole
2018-11-28T22:31:59Z    ecs-tasks.amazonaws.com                 AWSService      AssumeRole
2018-11-28T23:02:56Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:02:56Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:02:56Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:02:56Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:02:57Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:11Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:11Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:12Z    34.234.236.212  arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     CreateLogStream
2018-11-28T23:03:12Z    lambda.amazonaws.com                    AWSService      AssumeRole
2018-11-28T23:03:13Z    34.234.236.212  arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     CreateLogStream
2018-11-28T23:03:13Z    apigateway.amazonaws.com                        AWSService      Invoke
2018-11-28T23:03:14Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:17Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:18Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:03:20Z    34.234.236.212  arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     CreateLogStream
2018-11-28T23:03:20Z    apigateway.amazonaws.com                        AWSService      Invoke
2018-11-28T23:03:35Z    34.234.236.212  arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     CreateLogStream
2018-11-28T23:03:50Z    34.234.236.212  arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     CreateLogStream
2018-11-28T23:04:54Z    104.102.221.250 arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     ListObjects
2018-11-28T23:05:10Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:05:12Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:05:12Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:05:53Z    104.102.221.250 arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     ListImages
2018-11-28T23:06:17Z    104.102.221.250 arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     BatchGetImage
2018-11-28T23:06:33Z    104.102.221.250 arn:aws:sts::653711331788:assumed-role/level1/level1    653711331788    AssumedRole     GetDownloadUrlForLayer
2018-11-28T23:07:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:07:08Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:09:28Z    104.102.221.250 arn:aws:sts::653711331788:assumed-role/level3/d190d14a-2404-45d6-9113-4eda22d7f2c7      653711331788    AssumedRole     ListBuckets
2018-11-28T23:09:36Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
2018-11-28T23:09:36Z    104.102.221.250         ANONYMOUS_PRINCIPAL     AWSAccount      GetObject
`;

    const code15 = `──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq '.Records[]|select(.eventName=="ListBuckets")'                                                                                         
{
  "eventVersion": "1.05",
  "userIdentity": {
    "type": "AssumedRole",
    "principalId": "AROAJQMBDNUMIKLZKMF64:d190d14a-2404-45d6-9113-4eda22d7f2c7",
    "arn": "arn:aws:sts::653711331788:assumed-role/level3/d190d14a-2404-45d6-9113-4eda22d7f2c7",
    "accountId": "653711331788",
    "accessKeyId": "ASIAZQNB3KHGNXWXBSJS",
    "sessionContext": {
      "attributes": {
        "mfaAuthenticated": "false",
        "creationDate": "2018-11-28T22:31:59Z"
      },
      "sessionIssuer": {
        "type": "Role",
        "principalId": "AROAJQMBDNUMIKLZKMF64",
        "arn": "arn:aws:iam::653711331788:role/level3",
        "accountId": "653711331788",
        "userName": "level3"
      }
    }
  },
  "eventTime": "2018-11-28T23:09:28Z",
  "eventSource": "s3.amazonaws.com",
  "eventName": "ListBuckets",
  "awsRegion": "us-east-1",
  "sourceIPAddress": "104.102.221.250",
  "userAgent": "[aws-cli/1.16.19 Python/2.7.10 Darwin/17.7.0 botocore/1.12.9]",
  "requestParameters": null,
  "responseElements": null,
  "requestID": "4698593B9338B27F",
  "eventID": "65e111a0-83ae-4ba8-9673-16291a804873",
  "eventType": "AwsApiCall",
  "recipientAccountId": "653711331788"
`;

    const code16 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ aws-vault exec target_security -- aws iam get-role --role-name level3
{
    "Role": {
        "Path": "/",
        "RoleName": "level3",
        "RoleId": "AROAJQMBDNUMIKLZKMF64",
        "Arn": "arn:aws:iam::653711331788:role/level3",
        "CreateDate": "2018-11-23T17:55:27+00:00",
        "AssumeRolePolicyDocument": {
            "Version": "2012-10-17",
            "Statement": [
                {
                    "Sid": "",
                    "Effect": "Allow",
                    "Principal": {
                        "Service": "ecs-tasks.amazonaws.com"
                    },
                    "Action": "sts:AssumeRole"
                }
            ]
        },
        "Description": "Allows ECS tasks to call AWS services on your behalf.",
        "MaxSessionDuration": 3600,
        "RoleLastUsed": {
            "LastUsedDate": "2022-06-07T15:34:21+00:00",
            "Region": "us-east-1"
        }
    }
}
`;

    const code17 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq '.Records[]|select(.eventName=="ListImages")' 
{
  "eventVersion": "1.04",
  "userIdentity": {
    "type": "AssumedRole",
    "principalId": "AROAIBATWWYQXZTTALNCE:level1",
    "arn": "arn:aws:sts::653711331788:assumed-role/level1/level1",
    "accountId": "653711331788",
    "accessKeyId": "ASIAZQNB3KHGIGYQXVVG",
    "sessionContext": {
      "attributes": {
        "mfaAuthenticated": "false",
        "creationDate": "2018-11-28T23:03:12Z"
      },
      "sessionIssuer": {
        "type": "Role",
        "principalId": "AROAIBATWWYQXZTTALNCE",
        "arn": "arn:aws:iam::653711331788:role/service-role/level1",
        "accountId": "653711331788",
        "userName": "level1"
      }
    }
  },
  "eventTime": "2018-11-28T23:05:53Z",
  "eventSource": "ecr.amazonaws.com",
  "eventName": "ListImages",
  "awsRegion": "us-east-1",
  "sourceIPAddress": "104.102.221.250",
  "userAgent": "aws-cli/1.16.19 Python/2.7.10 Darwin/17.7.0 botocore/1.12.9",
  "requestParameters": {
    "repositoryName": "level2",
    "registryId": "653711331788"
  },
  "responseElements": null,
  "requestID": "2780d808-f362-11e8-b13e-dbd4ed9d7936",
  "eventID": "eb0fa4a0-580f-4270-bd37-7e45dfb217aa",
  "resources": [
    {
      "ARN": "arn:aws:ecr:us-east-1:653711331788:repository/level2",
      "accountId": "653711331788"
    }
  ],
  "eventType": "AwsApiCall",
  "recipientAccountId": "653711331788"
}
`;

    const code18 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq '.Records[]|select(.eventName=="BatchGetImage")'
{
  "eventVersion": "1.04",
  "userIdentity": {
    "type": "AssumedRole",
    "principalId": "AROAIBATWWYQXZTTALNCE:level1",
    "arn": "arn:aws:sts::653711331788:assumed-role/level1/level1",
    "accountId": "653711331788",
    "accessKeyId": "ASIAZQNB3KHGIGYQXVVG",
    "sessionContext": {
      "attributes": {
        "mfaAuthenticated": "false",
        "creationDate": "2018-11-28T23:03:12Z"
      },
      "sessionIssuer": {
        "type": "Role",
        "principalId": "AROAIBATWWYQXZTTALNCE",
        "arn": "arn:aws:iam::653711331788:role/service-role/level1",
        "accountId": "653711331788",
        "userName": "level1"
      }
    }
  },
  "eventTime": "2018-11-28T23:06:17Z",
  "eventSource": "ecr.amazonaws.com",
  "eventName": "BatchGetImage",
  "awsRegion": "us-east-1",
  "sourceIPAddress": "104.102.221.250",
  "userAgent": "aws-cli/1.16.19 Python/2.7.10 Darwin/17.7.0 botocore/1.12.9",
  "requestParameters": {
    "imageIds": [
      {
        "imageTag": "latest"
      }
    ],
    "repositoryName": "level2",
    "registryId": "653711331788"
  },
  "responseElements": null,
  "requestID": "35ea9256-f362-11e8-86cf-35c48074ab0a",
  "eventID": "b2867f3e-810c-47d1-9657-edb886e03fe6",
  "resources": [
    {
      "ARN": "arn:aws:ecr:us-east-1:653711331788:repository/level2",
      "accountId": "653711331788"
    }
  ],
  "eventType": "AwsApiCall",
  "recipientAccountId": "653711331788"
}
`;

    const code19 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ find . -type f -exec cat {} \\; | jq '.Records[]|select(.eventName=="GetDownloadUrlForLayer")'
{
  "eventVersion": "1.04",
  "userIdentity": {
    "type": "AssumedRole",
    "principalId": "AROAIBATWWYQXZTTALNCE:level1",
    "arn": "arn:aws:sts::653711331788:assumed-role/level1/level1",
    "accountId": "653711331788",
    "accessKeyId": "ASIAZQNB3KHGIGYQXVVG",
    "sessionContext": {
      "attributes": {
        "mfaAuthenticated": "false",
        "creationDate": "2018-11-28T23:03:12Z"
      },
      "sessionIssuer": {
        "type": "Role",
        "principalId": "AROAIBATWWYQXZTTALNCE",
        "arn": "arn:aws:iam::653711331788:role/service-role/level1",
        "accountId": "653711331788",
        "userName": "level1"
      }
    }
  },
  "eventTime": "2018-11-28T23:06:33Z",
  "eventSource": "ecr.amazonaws.com",
  "eventName": "GetDownloadUrlForLayer",
  "awsRegion": "us-east-1",
  "sourceIPAddress": "104.102.221.250",
  "userAgent": "aws-cli/1.16.19 Python/2.7.10 Darwin/17.7.0 botocore/1.12.9",
  "requestParameters": {
    "layerDigest": "sha256:2d73de35b78103fa305bd941424443d520524a050b1e0c78c488646c0f0a0621",
    "repositoryName": "level2",
    "registryId": "653711331788"
  },
  "responseElements": null,
  "requestID": "3f96ec7f-f362-11e8-bf5d-3380094c69db",
  "eventID": "ff4c72f3-4fbd-45d4-9ee3-3834a78f53de",
  "resources": [
    {
      "ARN": "arn:aws:ecr:us-east-1:653711331788:repository/level2",
      "accountId": "653711331788"
    }
  ],
  "eventType": "AwsApiCall",
  "recipientAccountId": "653711331788"
}
`;

    const code20 = `"requestParameters": {
    "imageIds": [
      {
        "imageTag": "latest"
      }
    ],
    "repositoryName": "level2",
    "registryId": "653711331788"
`;

    const code21 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ aws-vault exec target_security -- aws ecr get-repository-policy --repository-name level2                                                                                                                                                                    1 ⨯
{
    "registryId": "653711331788",
    "repositoryName": "level2",
    "policyText": "{\\n  \\"Version\\" : \\"2008-10-17\\",\\n  \\"Statement\\" : [ {\\n    \\"Sid\\" : \\"AccessControl\\",\\n    \\"Effect\\" : \\"Allow\\",\\n    \\"Principal\\" : \\"*\\",\\n    \\"Action\\" : [ \\"ecr:GetDownloadUrlForLayer\\", \\"ecr:BatchGetImage\\", \\"ecr:BatchCheckLayerAvailability\\", \\"ecr:ListImages\\", \\"ecr:DescribeImages\\" ]\\n  } ]\\n}"
`;

    const code22 = `┌──(kali㉿kali)-[~/…/us-east-1/2018/11/28]
└─$ aws-vault exec target_security -- aws ecr get-repository-policy --repository-name level2 | jq '.policyText|fromjson'
{
  "Version": "2008-10-17",
  "Statement": [
    {
      "Sid": "AccessControl",
      "Effect": "Allow",
      "Principal": "*",
      "Action": [
        "ecr:GetDownloadUrlForLayer",
        "ecr:BatchGetImage",
        "ecr:BatchCheckLayerAvailability",
        "ecr:ListImages",
        "ecr:DescribeImages"
      ]
    }
  ]
}
`;

    const code23 = `CREATE EXTERNAL TABLE \`cloudtrail\`(
    \`eventversion\` string COMMENT 'from deserializer', 
    \`useridentity\` struct<type:string,principalid:string,arn:string,accountid:string,invokedby:string,accesskeyid:string,username:string,sessioncontext:struct<attributes:struct<mfaauthenticated:string,creationdate:string>,sessionissuer:struct<type:string,principalid:string,arn:string,accountid:string,username:string>>> COMMENT 'from deserializer', 
    \`eventtime\` string COMMENT 'from deserializer', 
    \`eventsource\` string COMMENT 'from deserializer', 
    \`eventname\` string COMMENT 'from deserializer', 
    \`awsregion\` string COMMENT 'from deserializer', 
    \`sourceipaddress\` string COMMENT 'from deserializer', 
    \`useragent\` string COMMENT 'from deserializer', 
    \`errorcode\` string COMMENT 'from deserializer', 
    \`errormessage\` string COMMENT 'from deserializer', 
    \`requestparameters\` string COMMENT 'from deserializer', 
    \`responseelements\` string COMMENT 'from deserializer', 
    \`additionaleventdata\` string COMMENT 'from deserializer', 
    \`requestid\` string COMMENT 'from deserializer', 
    \`eventid\` string COMMENT 'from deserializer', 
    \`resources\` array<struct<arn:string,accountid:string,type:string>> COMMENT 'from deserializer', 
    \`eventtype\` string COMMENT 'from deserializer', 
    \`apiversion\` string COMMENT 'from deserializer', 
    \`readonly\` string COMMENT 'from deserializer', 
    \`recipientaccountid\` string COMMENT 'from deserializer', 
    \`serviceeventdetails\` string COMMENT 'from deserializer', 
    \`sharedeventid\` string COMMENT 'from deserializer', 
    \`vpcendpointid\` string COMMENT 'from deserializer')
ROW FORMAT SERDE 
    'com.amazon.emr.hive.serde.CloudTrailSerde' 
STORED AS INPUTFORMAT 
    'com.amazon.emr.cloudtrail.CloudTrailInputFormat' 
OUTPUTFORMAT 
    'org.apache.hadoop.hive.ql.io.HiveIgnoreKeyTextOutputFormat'
LOCATION
    's3://flaws2-logs/AWSLogs/653711331788/CloudTrail';
`;

    const code24 = `select eventtime, eventname from cloudtrail;
`;

    const code25 = `SELECT eventname, eventtime,
count(eventname) AS mycount 
FROM cloudtrail 
GROUP BY eventname, eventtime 
ORDER BY mycount;
`;

    return (
        <Layouts>
            <Breadcrumb breadcrumbText={'Blogs'}/>
            <div className={'!py-[100px]'}>
                <div className={'container mx-auto'}>
                    <div className={'lg:flex items-center justify-between !mb-7'}>
                        <div className={'md:flex items-center gap-10'}>
                            <div className={'flex items-center gap-4 !mb-5 lg:!mb-0'}>
                                <div>
                                    <img src={Author1} alt=""/>
                                </div>
                                <div>
                                    <h4 className={'text-base leading-6 text-[#04040C] font-semibold'}>Dayspring Johnson</h4>
                                </div>
                            </div>
                        </div>
                        <ul className="flex items-center gap-9">
                            <li className="flex items-center gap-2.5">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7082 9.00045C16.7082 13.2579 13.2573 16.7088 8.99984 16.7088C4.74234 16.7088 1.2915 13.2579 1.2915 9.00045C1.2915 4.74295 4.74234 1.29211 8.99984 1.29211C13.2573 1.29211 16.7082 4.74295 16.7082 9.00045Z" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.8594 11.4524L8.71777 9.57823V5.53906" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span className="text-sm text-[#828282]">Jun 10, 2022</span>
                            </li>
                        </ul>
                    </div>
                    <img src={Blog8_1} className={'!mb-7 rounded-[12px]'} alt=""/>
                    <h1 className={'text-[36px] text-[#1A1A1C] leading-[46px] font-bold !mb-5'}>Exploiting AWS 3 - Defender's Perspective (Flaws2.Cloud)</h1>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-8'}>In this path as a defender, you'll investigate a successful attack by using jq & Athena to analyze CloudTrail logs in JSON.</p>
                    <BlogDetailsAudio link={Blog8_2}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-7 !mt-5'}>This is a walkthrough of the flaws2.cloud challenge where you focus on AWS-specific issues, so no buffer overflows, XSS, etc. You can play by getting hands-on keyboard or just click through the hints to learn the concepts and go from one level to the next without playing.</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5'}>Defender</h3>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-10'}>In this Defender path, that target <a
                        href="https://daycyberwox.com/exploiting-aws-2-attackers-perspective-flaws2cloud" target={'_blank'} rel={'noreferrer'} className={'underline'}>Exploiting AWS 2 - Attacker's Perspective (Flaws2.Cloud)</a> is now viewed as the victim and you'll work as an Incident Responder for that same app, understanding how an attack happened.<br/>
                        You'll get access to logs of a previous successful attack and as the Defender, you'll learn the power of jq in analyzing logs, and instructions on how to set up Athena in your own environment.</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-6'}>Video Walkthrough:</h3>
                    <BlogDetailsVideo link={'https://www.youtube.com/watch?v=dfD8JQToZGE&t=1s'}/>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-6 !mt-10'}>Accessing the AWS Environment</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !my-5'}>Credentials</h6>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-5'}>Your IAM credentials to the Security account:</h6>
                    <BlogDetailsCode code={code1}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-5'}>These credentials give you access to the Security account, which can assume the role “security” in the Target account.</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-10'}>Preventing key leakage by using AWS-Vault</h3>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-6'}>I’ll be using aws-vault as it avoids storing the keys in plain text in your home directory as the AWS CLI does.</p>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Installation</h6>
                    <ul className={'!ml-7 !mb-4'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>First, install <a href="https://brew.sh/" className={'underline'} target={'_blank'} rel={'noreferrer'}>Homebrew</a> on your Linux host</li>
                    </ul>
                    <div>
                        <div className={'text-[17px] text-[#5F6C76] leading-7 !py-3 !px-5 rounded-lg bg-[#F4F4F4] inline-block !mb-2.5'}>/bin/bash -c "$(curl -fsSL</div>
                    </div>
                    <div>
                        <div className={'text-[17px] text-[#5F6C76] leading-7 !py-3 !px-5 rounded-lg bg-[#F4F4F4] inline-block !mb-2.5'}>[https://raw.githubusercontent.com/Homebrew/install/HEAD/install.sh]</div>
                    </div>
                    <div>
                        <div className={'text-[17px] text-[#5F6C76] leading-7 !py-3 !px-5 rounded-lg bg-[#F4F4F4] inline-block'}>(https://raw.githubusercontent.com/Homebrew/install/HEAD/install.sh))"</div>
                    </div>
                    <ul className={'!ml-7 !mt-5 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Add Homebrew to your PATH and to your bash shell profile</li>
                    </ul>
                    <BlogDetailsCode code={code2}/>
                    <div className={'md:flex items-center gap-2.5 !mb-5'}>
                        <ul className={'!ml-7 !mb-2.5 md:!mb-0'}>
                            <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Add Homebrew to your PATH and to your bash shell profile</li>
                        </ul>
                        <div className={'text-[17px] text-[#5F6C76] leading-7 !py-3 !px-5 rounded-lg bg-[#F4F4F4] inline-block'}>aws-vault</div>
                    </div>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-5'}>Usage</h6>
                    <BlogDetailsCode code={code3}/>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-6'}>Objective 1</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Download CloudTrail Logs</h6>
                    <ul className={'!ml-7 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Make a directory for the cloudtrail logs</li>
                    </ul>
                    <BlogDetailsCode code={code4}/>
                    <ul className={'!ml-7 !mt-10 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Download the CloudTrail Logs into the new directory</li>
                    </ul>
                    <BlogDetailsCode code={code5}/>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-6'}>Objective 2</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Access the Target account</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-3.5'}>A separate security account that has access to other AWS accounts, as well as access to CloudTrail logs from all other AWS accounts, has been set up for this environment. This is a common best practice that enables Cloud security investigations and incident response.</p>
                    <ul className={'!ml-7 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Let’s confirm that we have access to this “target” account.</li>
                    </ul>
                    <BlogDetailsCode code={code6}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-7'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76] !mb-3.5'}>Something to observe here is the account ID is now 653711331788, which is different from the original “security” account which has an account ID of 322079859186</li>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>List the buckets for the levels of the Attacker path using the “target_security” account</li>
                    </ul>
                    <BlogDetailsCode code={code7}/>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-6'}>Objective 3</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Use jq for investigation</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-6'}>jq is a very useful utility that can be used to manipulate JSON data.</p>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Installation</h6>
                    <div className={'text-[17px] text-[#5F6C76] leading-7 !py-3 !px-5 rounded-lg bg-[#F4F4F4] inline-block'}>sudo apt-get install jq</div>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5 !mt-6'}>Usage</h6>
                    <ul className={'!ml-7 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Navigate into the logs file directory</li>
                    </ul>
                    <BlogDetailsCode code={code8}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Find all files in every subdirectory, recursively, and attempt to gunzip them</li>
                    </ul>
                    <BlogDetailsCode code={code9}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Cat them through jq</li>
                    </ul>
                    <BlogDetailsCode code={code10}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-2.5 !mt-5 italic'}>Sample JSON log file result</p>
                    <BlogDetailsCode code={code11}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Filter out for only event names</li>
                    </ul>
                    <BlogDetailsCode code={code12}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Filter event name with time stamp</li>
                    </ul>
                    <ul className={'!ml-12 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76] !mb-3'}><div className={'text-[17px] text-[#5F6C76] leading-7 !p-1 rounded-lg bg-[#F4F4F4] inline-block'}>-cr</div> for printing data in a row</li>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}><div className={'text-[17px] text-[#5F6C76] leading-7 !p-1 rounded-lg bg-[#F4F4F4] inline-block'}>|@tsv</div> for tab separating</li>
                    </ul>
                    <BlogDetailsCode code={code13}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Further querying</li>
                    </ul>
                    <BlogDetailsCode code={code14}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-5'}>Output data can be copied into Excel or another spreadsheet which can sometimes make the data easier to work with.</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-4'}>Objective 4</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Identify credential theft</h6>
                    <ul className={'!ml-7 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Start by first investigating the ListBuckets API call</li>
                    </ul>
                    <BlogDetailsCode code={code15}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-2.5 !mb-2.5'}>The observed source IP address 104.102.221.250 is not AWS owned and will be viewed as the attacker’s IP.</p>
                    <ul className={'!ml-7 !mb-2.5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Investigate the Role/User that performed the action level3</li>
                    </ul>
                    <BlogDetailsCode code={code16}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-5'}>The observed role arn:aws:iam::653711331788:role/level3 is only supposed to be run by the Amazon ECS service ecs-tasks.amazonaws.com , however the observed source IP from before 104.102.221.250 was confirmed to be a non-AWS IP address.<br/>
                        We can safely assume that this role was compromised since it’s ListBuckets API call was from a non-AWS IP Address since normal activity would be API calls from the AWS ECS service’ IP Address.</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-4'}>Objective 5</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Identify the public resource</h6>
                    <ul className={'!ml-7 !mb-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Let’s investigate the ListImages, BatchGetImage, and GetDownloadUrlForLayer API Calls observed from our previous investigations</li>
                    </ul>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>ListImages</h6>
                    <BlogDetailsCode code={code17}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5 !mt-6'}>BatchGetImage</h6>
                    <BlogDetailsCode code={code18}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5 !mt-6'}>GetDownloadUrlForLayer</h6>
                    <BlogDetailsCode code={code19}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>As observed from level2</li>
                    </ul>
                    <BlogDetailsCode code={code20}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Investigate the policy using the repository name level2</li>
                    </ul>
                    <BlogDetailsCode code={code21}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Clean the results up using jq</li>
                    </ul>
                    <BlogDetailsCode code={code22}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-5'}>As observed the Principal is “*” which means the actions can be performed by anyone including anyone on the internet. Basically, the ECR is public.<br/>Scott mentions that “Ideally, you'd use a tool like CloudMapper to scan an account for public resources like this before you trace back an attack.”</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-4'}>Objective 6</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Use Athena</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Log in to your personal AWS account and access Athena</p>
                    <ul className={'!ml-7 !mb-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Create a database</li>
                    </ul>
                    <img src={Blog8_3} alt=""/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-6'}><a className={'underline'} href="https://s3-us-west-2.amazonaws.com/secure.notion-static.com/ae04ecf0-5366-4677-bdd6-0b1f7f075b8c/Untitled.png">Untitled</a></p>
                    <ul className={'!ml-7 !mb-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Switch to the flaws2 database you just created</li>
                    </ul>
                    <img src={Blog8_4} alt=""/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Run the following</li>
                    </ul>
                    <BlogDetailsCode code={code23}/>
                    <ul className={'!ml-7 !mb-2.5 !mt-6'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Then run the following</li>
                    </ul>
                    <BlogDetailsCode code={code24}/>
                    <img src={Blog8_5} className={'w-full !mt-5'} alt=""/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mt-6'}><a className={'underline'} href="https://s3-us-west-2.amazonaws.com/secure.notion-static.com/4dcceea2-0e9c-4053-8493-f8ba51d87180/Untitled.png">Untitled</a></p>
                    <ul className={'!ml-7 !mb-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Regular SQL queries can then be run against this data, e.g</li>
                    </ul>
                    <BlogDetailsCode code={code25}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-7 !mb-2.5'}>Closing notes from Scott:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-2.5 italic'}>“Athena is great for incident response because you don't have to wait for the data to load anywhere, just define the table in Athena and start querying it. If you do so, you should also create partitions which will reduce your costs by helping you query only against a specific day. Alex Smolen gives a good explanation on how to do that in his article Partitioning CloudTrail Logs in Athena.”</p>
                    <h6 className={'text-[18px] text-[#272728]'}><a className={'underline'} href="https://alsmola.medium.com/partitioning-cloudtrail-logs-in-athena-29add93ee070" target={'_blank'} rel={'noreferrer'}>Alex Smolen’s Article</a></h6>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mt-10 !mb-4'}>The End</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Use Athena</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>This was a fun series of challenges and a great learning experience. Some key skills learned:</p>
                    <ul className={'!ml-7 !mb-5'}>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Assuming roles in other AWS accounts</li>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Reading IAM and resource policies</li>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Querying JSON logs with JQ & Athena</li>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Using SQL</li>
                        <li className={'list-disc text-[17px] leading-7 text-[#5F6C76]'}>Working with CloudTrail logs</li>
                    </ul>
                    <div className="flex items-center gap-8 !mt-10">
                        <p className="font-medium text-base text-[#5F6C76]">Share this post: </p>
                        <div className="flex items-start gap-[30px]">
                            <a href="https://www.linkedin.com/in/dayspringjohnson/?fbclid=IwAR1NBvGpFwDH2puRt89zN4TdYzNBzlXQ23T3BxutDbrhSTsrNpW1xG21NE4" target={'_blank'} rel={'noreferrer'}>
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.36198 2.58425C4.36173 3.07049 4.16835 3.5367 3.82436 3.88034C3.48038 4.22399 3.01396 4.41691 2.52773 4.41667C2.0415 4.41643 1.57528 4.22304 1.23164 3.87905C0.887987 3.53506 0.695065 3.06865 0.695313 2.58242C0.69556 2.09619 0.88894 1.62997 1.23293 1.28632C1.57692 0.942683 2.04334 0.749762 2.52956 0.75C3.01579 0.750248 3.48202 0.943637 3.82566 1.28763C4.16931 1.63161 4.36223 2.09802 4.36198 2.58425ZM4.41698 5.77425H0.750313V17.2509H4.41698V5.77425ZM10.2103 5.77425H6.56198V17.2509H10.1736V11.2284C10.1736 7.8734 14.5461 7.56173 14.5461 11.2284V17.2509H18.167V9.98173C18.167 4.32592 11.6953 4.53675 10.1736 7.31423L10.2103 5.77425Z" fill="#1A1A1C"/>
                                </svg>
                            </a>
                            <a href="https://twitter.com/DayCyberwox?fbclid=IwAR1NBvGpFwDH2puRt89zN4TdYzNBzlXQ23T3BxutDbrhSTsrNpW1xG21NE4" target="_blank" rel={'noreferrer'}>
                                <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.1962 2.68178C19.4689 3.00078 18.694 3.21222 17.8862 3.31489C18.7173 2.81867 19.3516 2.03889 19.6498 1.099C18.8749 1.561 18.0194 1.88734 17.1076 2.06945C16.3718 1.286 15.3232 0.800781 14.1792 0.800781C11.9596 0.800781 10.1727 2.60234 10.1727 4.81089C10.1727 5.12867 10.1996 5.43422 10.2656 5.72511C6.93262 5.56256 3.9834 3.96511 2.00218 1.53167C1.65629 2.13178 1.4534 2.81867 1.4534 3.55811C1.4534 4.94656 2.1684 6.17734 3.23418 6.88989C2.59006 6.87767 1.95818 6.69067 1.42284 6.39611C1.42284 6.40834 1.42284 6.42422 1.42284 6.44011C1.42284 8.38834 2.81251 10.0066 4.63484 10.3793C4.30851 10.4686 3.95284 10.5113 3.58373 10.5113C3.32706 10.5113 3.06795 10.4967 2.82473 10.4429C3.34418 12.0306 4.81818 13.1978 6.57084 13.2357C5.20684 14.3027 3.47495 14.9456 1.60006 14.9456C1.27129 14.9456 0.955958 14.9309 0.640625 14.8906C2.41651 16.0358 4.52118 16.6897 6.79084 16.6897C14.1682 16.6897 18.2015 10.5786 18.2015 5.28145C18.2015 5.10422 18.1954 4.93311 18.1868 4.76322C18.9825 4.19856 19.651 3.49334 20.1962 2.68178Z" fill="#1A1A1C"/>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/DayCyberwox/?fbclid=IwAR2QMOkHInPPTOV_nygxdL4X3WjOIQ7niH5pdQASypCJGzqVxE_nwsY3qCc" target="_blank" rel={'noreferrer'}>
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.52539 0H13.2754C16.3816 0 18.9004 2.51887 18.9004 5.625V12.375C18.9004 15.4812 16.3816 18 13.2754 18H6.52539C3.41926 18 0.900391 15.4812 0.900391 12.375V5.625C0.900391 2.51887 3.41926 0 6.52539 0ZM13.2754 16.3125C15.4467 16.3125 17.2129 14.5462 17.2129 12.375V5.625C17.2129 3.45375 15.4467 1.6875 13.2754 1.6875H6.52539C4.35414 1.6875 2.58789 3.45375 2.58789 5.625V12.375C2.58789 14.5462 4.35414 16.3125 6.52539 16.3125H13.2754Z" fill="#1A1A1C"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.40039 9C5.40039 6.51487 7.41527 4.5 9.90041 4.5C12.3856 4.5 14.4004 6.51487 14.4004 9C14.4004 11.4852 12.3856 13.5 9.90041 13.5C7.41527 13.5 5.40039 11.4852 5.40039 9ZM7.08789 9C7.08789 10.5502 8.35014 11.8125 9.90041 11.8125C11.4507 11.8125 12.7129 10.5502 12.7129 9C12.7129 7.44862 11.4507 6.1875 9.90041 6.1875C8.35014 6.1875 7.08789 7.44862 7.08789 9Z" fill="#1A1A1C"/>
                                    <path d="M14.7383 4.76175C15.0695 4.76175 15.3379 4.49329 15.3379 4.16212C15.3379 3.83096 15.0695 3.5625 14.7383 3.5625C14.4071 3.5625 14.1387 3.83096 14.1387 4.16212C14.1387 4.49329 14.4071 4.76175 14.7383 4.76175Z" fill="#1A1A1C"/>
                                </svg>
                            </a>
                            <a href="https://www.youtube.com/@DayCyberwox/videos" target="_blank" rel={'noreferrer'}>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" rel={'noreferrer'}>
                                    <g clip-path="url(#clip0_321_335)">
                                        <path d="M3.73258 7.49094C5.49341 6.32096 7.43198 5.69401 9.58052 5.63378C9.91941 4.00567 10.2593 2.3904 10.5913 0.774144C10.7505 -0.0018965 10.8462 -0.0680475 11.6041 0.0869632C12.5904 0.288378 13.5758 0.490781 14.5661 0.665538C14.7185 0.692196 14.9411 0.617159 15.0554 0.507565C15.5906 -0.00782043 16.2908 -0.150983 16.8875 0.171873C17.4608 0.482882 17.7889 1.16908 17.659 1.78813C17.5145 2.47433 17.0213 2.93442 16.3621 2.99958C15.6052 3.07462 15.0857 2.72708 14.7712 1.98066C14.7068 1.82861 14.5407 1.65188 14.3923 1.61831C13.445 1.40307 12.4889 1.22437 11.4839 1.02394C11.1597 2.58886 10.8374 4.14094 10.5083 5.73054C12.6149 5.82927 14.5524 6.40587 16.2918 7.60449C16.9393 7.08811 17.6415 6.86794 18.4413 7.1207C19.2568 7.37839 19.7783 7.94215 19.9482 8.77447C20.1221 9.62456 19.8642 10.3591 19.1972 10.9407C19.0576 11.0621 18.8974 11.2635 18.8974 11.4274C18.9013 13.5689 17.8788 15.123 16.1785 16.2634C13.9577 17.7532 11.4751 18.1758 8.86467 17.9389C7.02474 17.771 5.302 17.2211 3.78727 16.1153C2.22372 14.9739 1.24906 13.5038 1.29203 11.4709C1.29496 11.3257 1.19535 11.1253 1.07913 11.0384C-0.0586175 10.1804 -0.324255 8.93837 0.417968 7.86021C1.1475 6.80179 2.4376 6.6221 3.59586 7.4169C3.63395 7.44257 3.67789 7.46133 3.73258 7.49094ZM11.9469 10.7827C11.9498 11.6456 12.6549 12.3308 13.5524 12.3437C14.2849 12.3535 14.9275 11.618 14.9177 10.7797C14.9079 9.90398 14.2604 9.25925 13.404 9.27209C12.5729 9.28492 11.9429 9.93656 11.9469 10.7827ZM6.44072 12.2084C7.25717 12.2015 7.93591 11.5173 7.93787 10.6998C7.93982 9.86745 7.23764 9.18323 6.39385 9.19606C5.57252 9.20791 4.91526 9.89213 4.92795 10.7225C4.94163 11.5489 5.61939 12.2153 6.44072 12.2084ZM9.8823 16.0501C11.3951 16.0748 12.2838 15.8102 13.4918 15.0351C13.736 14.8791 13.9548 14.7271 13.7702 14.4279C13.5758 14.113 13.3122 14.2285 13.0524 14.3884C11.0337 15.6325 9.00823 15.6216 6.98567 14.3993C6.73078 14.2453 6.47588 14.1001 6.26591 14.4161C6.04813 14.7429 6.30204 14.9236 6.54131 15.0835C7.57554 15.7727 8.71427 16.0906 9.8823 16.0501Z" fill="black"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_321_335">
                                            <rect width="20" height="18" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Layouts>
    )
}

export default Blog8;
